import axios from "axios";
import { useContext, useEffect, useState } from "react";
import { CloseOutlined, ArrowBack } from "@material-ui/icons";
import TestTable from "../alltests/table";
import { AIModal } from "./AIModal";

import "./ExamModal.css";
import { useTests } from "../hooks/useTests";
import { GlobalContext } from "../../../../context/GlobalState";

const ExamModal = ({ handleClose }) => {
  const {userDetails} = useContext(GlobalContext);
  const [view, setView] = useState("list");
  const [examLink, setExamLink] = useState(null);

  const { exams, loading } = useTests({grade:userDetails.grade,section:userDetails.section});
 
  const openExam = async (examId) => {
    setView("loading");

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_ORIGIN}/api/v1/grades/VI/sections/A/exams/${examId}`,
        {
          headers: {
            token: window.localStorage.getItem("authToken"),
          },
        },
      );

      setExamLink(response.data?.link);
      setView("iframe");
    } catch (err) {
      console.error(err);
      setView("list");
    }
  };

  const handleBack = () => {
    setExamLink(null);
    setView("list");
  };

  return (
    <AIModal onClose={handleClose}>
      {/* ===== Header ===== */}
      <div className="exam-header">
        <div className="exam-header-left">
          {view === "iframe" && (
            <button className="exam-back-btn" onClick={handleBack}>
              <ArrowBack fontSize="small" />
              Back
            </button>
          )}
          <h3 className="exam-title">
            {view === "iframe" ? "Exam" : "Available Exams"}
          </h3>
        </div>

        <button className="exam-close-btn" onClick={handleClose}>
          <CloseOutlined />
        </button>
      </div>

      {/* ===== Body ===== */}
      <div className="exam-body">
        {view === "list" && (
          <TestTable
            rows={exams}
            loading={loading}
            onRowClick={(exam) => openExam(exam.id)}
          />
        )}

        {view === "loading" && (
          <div className="exam-loader-container">
            <div className="exam-loader"></div>
            <p>Loading exam...</p>
          </div>
        )}

        {view === "iframe" && examLink && (
          <iframe
            title="Exam"
            src={examLink}
            className="exam-iframe"
            allowFullScreen
          />
        )}
      </div>
    </AIModal>
  );
};

export default ExamModal;
